export const SET_PRATT_TABLE  = "SET_PRATT_TABLE"
export const SET_SHILTS_TABLE = "SET_SHILTS_TABLE"